import { Injectable } from '@angular/core';
import {AbstractLocalStorageService} from "../abstract-local-storage.service";

export const STATE_UPDATE_FREQUENCY_DEFAULT = 30;
export const STATE_UPDATE_FREQUENCY_MIN = 10;

@Injectable({
  providedIn: 'root'
})
export class UnitStateUpdateFrequencyLocalStorageService extends AbstractLocalStorageService<number> {
  protected getItemKey(): string {
      return 'unit-state-update-frequency';
  }
  protected getDefaultValue(): number {
      return STATE_UPDATE_FREQUENCY_DEFAULT;
  }

  constructor() {
    super();
  }
}
